import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { useSelector } from 'react-redux';

// import stack components
import CollectionEdit from 'js/containers/stack/collection/Collection.edit';
import CollectionSave from 'js/containers/stack/collection/Collection.save';
import CollectionAdd from 'js/containers/stack/collection/Collection.add';
import CollectionCreate from 'js/containers/stack/collection/Collection.create';
import CollectionShare from 'js/containers/stack/collection/Collection.share';
import CollectionDelete from 'js/containers/stack/collection/Collection.delete';

export const STATES = {
  ADD: 'add',
  EDIT: 'edit',
  SHARE: 'share',
  DELETE: 'delete',
  CREATE: 'create',
  SAVE: 'save',
};

const STATE_COMPONENTS = {
  [STATES.ADD]: (card, cb, closeModal) => {
    return <CollectionAdd card={card} switchState={cb} closeModal={closeModal} />;
  },
  [STATES.EDIT]: (card, cb, closeModal, collectionID) => {
    return <CollectionEdit card={card} switchState={cb} closeModal={closeModal} collectionID={collectionID} />;
  },
  [STATES.CREATE]: (card, cb, closeModal) => {
    return <CollectionCreate card={card} switchState={cb} closeModal={closeModal} />;
  },
  [STATES.SHARE]: (card, cb, closeModal, collectionID) => {
    return <CollectionShare card={card} collectionID={collectionID} switchState={cb} closeModal={closeModal} />;
  },
  [STATES.DELETE]: (card, cb, closeModal, collectionID) => {
    return <CollectionDelete card={card} switchState={cb} closeModal={closeModal} collectionID={collectionID} />;
  },
  [STATES.SAVE]: (card, cb, closeModal, collectionID, collectionData) => {
    return <CollectionSave card={card} switchState={cb} closeModal={closeModal} collectionData={collectionData} />;
  },
};

const CollectionModal = ({ modalState, cardID, collectionID, collectionData, closeModal }) => {
  const userHasCollections = useSelector((state) => state?.collections?.userCollections?.allIds?.length > 0);
  const state = modalState || STATES.ADD;
  const [componentState, setComponentState] = useState(
    state == STATES.ADD && !userHasCollections ? STATES.CREATE : state
  );
  const card = useSelector((state) => state?.cards?.byId[cardID] || false);

  return (
    <AnimatePresence mode="wait">
      <motion.div
        key={componentState}
        variants={variants}
        initial="initial"
        animate="animate"
        exit="exit"
        className="collection-modal"
      >
        {STATE_COMPONENTS[componentState](
          card,
          (newState) => setComponentState(newState, {}),
          closeModal,
          collectionID,
          collectionData
        )}
      </motion.div>
    </AnimatePresence>
  );
};

export default CollectionModal;

const variants = {
  initial: {
    opacity: 0,
    y: 80,
  },
  animate: {
    opacity: 1,
    y: 0,
    transition: {
      type: 'spring',
      stiffness: 120,
      damping: 18,
      mass: 0.8,
    },
  },
  exit: {
    opacity: 0,
    y: 80,
    filter: 'blur(4px)',
    transition: {
      duration: 0.3,
      ease: 'easeIn',
    },
  },
};
